import {Botao, BotaoAdicionar, BotaoEnviar, BotaoExcluir, PaginaLogada} from "../../componentes";
import {Card} from "../../componentes/card/Card";
import CardHeader from "react-bootstrap/CardHeader";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {
  exibirMensagemErro,
  exibirMensagemPergunta, exibirMensagemSucesso,
  formatarData,
  formatarDinheiro,
  formatarDinheiroItl, formatarDinheiroParaDecimal,
  HttpVerbo,
  xfetch
} from "../../util";
import {formatarDataHora, formatarDataLocalDate} from "../../util/mascara";
import {ICONE} from "../../config/constantes/constantes";

export default function AtualizacaoMonetaria() {

  const parametros = useParams()
  const [conta, setConta] = useState({})
  const [consolidacao, setConsolidacao] = useState({})
  const [isCarregando, setIsCarregando] = useState(false)
  const [hasDescricao, setHasDescricao] = useState(true)
  const [reload, setReload] = useState(false)
  const [dados, setDados] = useState({
    valor: '',
    saida: -1,
    descricao: '',
    idConta: -1,
    dataAcao: ''
  })


  function consultarConta() {
    setIsCarregando(true)
    const idConta = parametros.idConta
    xfetch(`/conta/${idConta}`, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => setConta(dados))
      .finally(() => setIsCarregando(false))
  }

  function consultarConsolidacoes() {
    setIsCarregando(true)
    const idConta = parametros.idConta
    xfetch(`/conta/${idConta}/consolidacao`, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => setConsolidacao(dados))
      .finally(() => setIsCarregando(false))
  }

  function salvar() {
    setIsCarregando(true)
    const idConta = parametros.idConta

    const dadosEntrada = {
      idConta: idConta,
      valor: formatarDinheiroParaDecimal(dados.valor),
      descricao: dados.descricao,
      saida: dados.saida,
      dataAcao: dados.dataAcao
    }

    if (dadosEntrada.saida == -1) {
      exibirMensagemErro("Um tipo precisa ser informado")
      setIsCarregando(false)
      return
    }

    if (!dadosEntrada.valor) {
      exibirMensagemErro("Um valor precisa ser informado")
      setIsCarregando(false)
      return;
    }


    let confirma = true;
    if (!dadosEntrada.descricao) {
      let confirma = window.confirm("Deseja cadastrar o valor sem descrição?")
      if (!confirma) {
        setIsCarregando(false)
        return;
      }
    }
    xfetch(`/conta/${idConta}/atualizacao`, dadosEntrada, HttpVerbo.POST)
      .then(data => {
        exibirMensagemSucesso("Atualização feita com sucesso.")
        setDados({
          saida: -1,
          descricao: '',
          valor: '',
          dataAcao: ''
        })
        consultarConsolidacoes()
        // setReload(!reload)
      })
      .finally(() => setIsCarregando(false))
  }

  useEffect(() => {
    consultarConta()
    consultarConsolidacoes()
  }, []);


  function excluir(id) {
    let resposta = window.confirm('Deseja realmente excluir essa atualização?')

    if (resposta) {
      setIsCarregando(true)
      xfetch('/conta/atualizacao/remover', {id: id}, HttpVerbo.POST)
        .then(res => {
          if (res.status === 200) {
            exibirMensagemSucesso("Atualizacao removida com sucesso.")
            consultarConsolidacoes()
          }
        })
        .finally(() => setIsCarregando(false))
      return;
    }
  }
//18.025.508,00
  return(
    <PaginaLogada titulo="Atualizar conta" botaoVoltar={true} isCarregando={isCarregando}>
      <div className="row">
        <div className="col-lg-12">
          <Card>
            <CardHeader>Atualização monetária</CardHeader>
            <div className="card-body">
              <div className="row">
                <div className="col-lg">
                  <h4>Banco: <b>{conta.banco}</b></h4>
                </div>
                <div className="col-lg">
                  <h4>Agencia: <b>{conta.agencia}</b></h4>
                </div>

                <div className="col-lg">
                  <h4>Conta: <b>{conta.conta}</b></h4>
                </div>

                <div className="col-lg">
                  <h4>Valor em Conta: <b>{ formatarDinheiroItl(consolidacao.valorEmConta)}</b></h4>
                </div>
              </div>


              <div className="row mt-4">
                <div className="col-lg">
                  <label>Valor para atualizar:</label>
                  <input className="form-control" placeholder="Valor"
                         value={dados.valor}
                         onChange={(e) => setDados({...dados, valor: formatarDinheiro(e.target.value)})}/>
                </div>
                <div className="col-lg">
                  <label>Data da ação:</label>
                  <input type="date" className="form-control" placeholder="Data ação"
                         value={dados.dataAcao}
                         onChange={(e) => setDados({...dados, dataAcao: e.target.value})}/>
                </div>

                <div className="col-lg">
                  <label>Tipo de atualização:</label>
                  <select className="form-control"
                          onChange={(e) => {
                            if (e.currentTarget.value == -2) {
                              setDados({...dados, saida: false, descricao: "RENDIMENTO"})
                              setHasDescricao(false)
                              return
                            } else {
                              setHasDescricao(true)
                              setDados({...dados, saida: e.currentTarget.value, descricao: ""})
                            }
                          }}>
                    <option value="-1">Selecione o tipo</option>
                    <option value="false">Entrada</option>
                    <option value="true">Saida</option>
                    <option value="-2">Rendimento</option>
                  </select>
                </div>

                <div className="col-lg">
                  <label>Descrição:</label>
                  <input readOnly={!hasDescricao} type="text" value={dados.descricao} className="form-control"
                         onChange={(e) => setDados({...dados, descricao: e.target.value})}/>
                </div>

                <div className="col-lg mt-4">
                  <BotaoAdicionar onClick={salvar} className="mt-1"/>
                </div>
              </div>
            </div>
          </Card>
          <Card>
            <CardHeader>Movimentações:</CardHeader>
            <div className="row">
              <div className="col-12">
                <table className="table table-striped table-bordered table-hover border-info border-1 border-dark">
                  <thead>
                  <tr>
                    <th>Tipo:</th>
                    <th>Valor:</th>
                    <th>Força</th>
                    <th>Data:</th>
                    <th>Descrição:</th>
                    <th>Usuário:</th>
                    <th>Ação:</th>
                  </tr>
                  </thead>
                  <tbody>
                    {consolidacao?.consolidacoes?.map((v, k) => {
                      return (
                          <tr key={k} style={{backgroundColor: v.saida ? "#ffd8d8" : "#dbffdb"}}>
                            <td>{v.saida ? "SAÍDA" : "ENTRADA"}</td>
                            <td>{formatarDinheiroItl(v.valor)}</td>
                            <td>{v.item ? v.item.forca.nome : ''}</td>
                            <td>{v.dataAcao ? formatarDataLocalDate(v.dataAcao) : formatarData(v.dataHora)}</td>
                            <td>{v.item ? "Compra de item - " + v.item.nome : v.descricao}</td>
                            <td>{consolidacao?.cadastrantes.filter(c => c.id === v.cadastrante)[0].nome}</td>
                            <td>
                              <div className={v.item ? 'd-none' : ''}>
                                <Botao icone={ICONE.TIPO.EXCLUIR} cor="danger" onClick={() => excluir(v.id)}/>
                              </div>
                            </td>
                          </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </PaginaLogada>
  )
}